import { render } from "./HedgeFunds.vue?vue&type=template&id=9ae853b8&scoped=true&ts=true"
import script from "./HedgeFunds.vue?vue&type=script&lang=ts"
export * from "./HedgeFunds.vue?vue&type=script&lang=ts"

import "./HedgeFunds.vue?vue&type=style&index=0&id=9ae853b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ae853b8"]])

export default __exports__